import type { RootState } from "single-spa/store/types";

export const selectSegmentGroupId = (state: RootState) => state.customDashboard.dashboardTemplate.segmentGroupId;
export const selectSegmentIds = (state: RootState) => state.customDashboard.dashboardTemplate.selectedSegments;
